export const CHECKOUT_BREAKDOWN = "Checkout breakdown";
export const EXPERIENCE_TOTAL = "Total";
export const TAXES_AND_FEES = "Taxes & Fees";
